const aiChatMessageStyles = {
  messageContainer: {
    minWidth: 0,
    "@media (hover: hover)": {
      "&:hover .AiChatMessage-hoverAction": {
        display: "inline-flex",
      },
    },
  },
  humanMessageContainer: {
    alignItems: "flex-end",
    alignSelf: "flex-end",
    maxWidth: "70%",
  },
  assistantMessageContainer: {
    width: "100%",
  },
  message: {
    padding: ".5rem",
  },
  humanMessage: {
    backgroundColor: "primary.main",
    color: "primary.contrastText",
    alignSelf: "flex-end",
  },
  assistantMessage: {
    alignSelf: "flex-start",
  },
  feedbackIcon: {
    transform: "scale(0.8)",
  },
  messageActions: {
    minHeight: "2.125rem",
    alignItems: "center",
  },
  copyAction: {
    display: "none",
  },
  copyActionVisible: {
    display: "inline-flex",
  },
  editor: {
    backgroundColor: "background.paper",
    color: "text.primary",
    minWidth: "20rem",
    padding: "0.5rem",
  },
  editorInput: {
    alignItems: "flex-start",
    padding: "0.5rem",
    width: "100%",
  },
  editorActions: {
    justifyContent: "flex-end",
    marginTop: "0.5rem",
  },
  branchActions: {
    alignItems: "center",
    marginLeft: "auto",
  },
};

export default aiChatMessageStyles;
